export default "__VITE_ASSET__DRuIWSCc__"